import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16l-7-8v8H5l7-8V5h7v14z"
}), 'FilterBAndW');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/FilterBAndW.js
// module id = 3625
// module chunks = 2